export enum BackendTestAppsEnvironment {
  ALPHA = 'alpha',
  BETA = 'beta',
  GAMMA = 'gamma',
}

export enum ClientCredentialsTarget {
  CORE_CC = 'core-cc',
  PLUTUS_CC = 'plutus-cc',
  APOLLO_CC = 'apollo-cc',
}

export interface UserAccessTokenPayload {
  token?: string;
  accessToken?: string;
  expiresAt?: number | string;
  expires_in?: number;
}

export interface UserAccessToken {
  accessToken: string;
  expiresAt?: number;
}

export interface ClientToken {
  access_token?: string;
  token_type?: string;
  expires_in?: number;
  expires_at?: number;
}

export interface ClientCredentialsProviderConfig {
  url?: string;
  body: {
    grant_type?: string;
    client_id?: string;
    client_secret?: string;
    audience?: string;
  };
}
